import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ targetDate, label }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const difference = new Date(targetDate) - new Date();
    
    if (difference <= 0) {
      return { expired: true };
    }

    return {
      expired: false,
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60),
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  if (timeLeft.expired) {
    return (
      <div className="text-center">
        <p className="text-[#E8651A] font-['Oswald'] text-lg tracking-wider">RALLY IN PROGRESS</p>
      </div>
    );
  }

  const timeBlocks = [
    { value: timeLeft.days, label: 'DAYS' },
    { value: timeLeft.hours, label: 'HRS' },
    { value: timeLeft.minutes, label: 'MIN' },
    { value: timeLeft.seconds, label: 'SEC' },
  ];

  return (
    <div data-testid="countdown-timer">
      {label && (
        <p className="text-[#A19D98] text-xs text-center mb-3 tracking-wider uppercase">
          {label}
        </p>
      )}
      <div className="flex justify-center gap-2 sm:gap-4">
        {timeBlocks.map((block, i) => (
          <div key={i} className="text-center">
            <div className="bg-[#1C1C1C] border border-[#2A2A2A] w-14 sm:w-16 h-14 sm:h-16 flex items-center justify-center">
              <span className="font-['Oswald'] text-2xl sm:text-3xl text-[#F2EDE6]">
                {String(block.value).padStart(2, '0')}
              </span>
            </div>
            <p className="text-[#A19D98] text-[10px] mt-1 tracking-wider">
              {block.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CountdownTimer;
